import styled from 'styled-components';

export const BoxedStyled = styled.section`
  margin: 10px auto;
  width: 500px;
  padding: 16px;
  border-radius: 12px;
  background-color: var(--bg-surface);
  border: 1px solid var(--border-color);
  box-shadow: var(--card-shadow);
`;

export const BoxedResponsiveStyled = styled.section`
  margin: 10px auto;
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  min-height: 200px;
  background-color: var(--bg-surface);
  border: 1px solid var(--border-color);
  box-shadow: var(--card-shadow);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    border-color: var(--border-color-hover);
    box-shadow: var(--card-shadow-hover);
    transform: translateY(-2px);
  }
  
  h3 {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 12px 0;
    display: grid;
    align-items: flex-start;
    grid-template-columns: auto 1fr;
    grid-gap: 8px;
  }
  
  &.without-margin {
    margin-top: 0;
  }
`;

export const ServersListStyled = styled.section`
  margin: 10px auto;
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  min-height: 200px;
  
  h3{
    font-size: 18px;
    margin: 0 0 10px 0;
    display: grid;
    align-items: flex-start;
    grid-template-columns: auto 1fr;
    grid-gap: 5px;
  }
  
  &.without-margin{
    margin-top: 0;
  }
`;

export const MarginTopStyled = styled.div`
  margin: 17px 0;
`;

export const SoonStyled = styled.div`
  text-align: center;
  font-size: 24px;
  display: grid;
  align-content: center;
  justify-content: center;
  height: 100%;
`;

export const EmptyWidgetStyled = styled.div`
  text-align: center;
  font-size: 15px;
`;

export const CodeAreaStyled = styled.pre`
  white-space: pre-wrap;
  background-color: black;
  color: white;
  font-size: medium;
  font-family: Consolas, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace;
  width: 100%;
  display: inline-block;

  line-height: 1.4;
  margin: 10px 0 25px;
  padding: 10px;

   @media (max-width: 600px) {
    word-break: break-all;
  }
`;

export const RunCodeStyled = styled.div`
  text-align: center;
  margin: 20px;

  .done {

  }
`;

export const FlowStyled = styled.div`
  width: 540px;
  margin: 40px auto;
  font-size: 17px;

  h3 {
    font-size: 23px;
    text-align: center;
  }

  ul {
    margin: 10px 0;
    list-style: auto;
    text-align: left;
  }

  li {
    margin: 9px 0;
    line-height: 1.3;
  }


   @media (max-width: 600px) {
    width: 100%;
    padding: 10px 40px;
  }
`;

export const GoBackStyled = styled.div`
  
`;
